import {TextInput, TagArea} from "components/core";
import { useFormik } from "formik";
import { FC } from "react";
import { wrapClick } from "utils";
import {
  IResolveFATServiceOrderFormSchema,
  ProductInfoSchema,
} from "./schema";

export interface ProductInfoFormProps {
  handleNext: (values: IResolveFATServiceOrderFormSchema["productInfo"]) => void;
  handlePrevious: () => void;
  initialValues: IResolveFATServiceOrderFormSchema["productInfo"];
  values: IResolveFATServiceOrderFormSchema;
  handleCancel: () => void;
  meterContractor: any;
}

const ProductInfoForm: FC<ProductInfoFormProps> = ({
  initialValues,
  handleNext,
  handleCancel,
  handlePrevious,
  meterContractor,
}) => {

  const form = useFormik({
    initialValues,
    validationSchema: ProductInfoSchema,
    onSubmit: (values) => {
      handleNext(values);
    },
    onReset: () => {
      handleCancel?.();
    },
  });

  return (
    <div className="flex-1 flex flex-col overflow-hidden">
      <div className="space-y-6 divide-y divide-gray-200 p-6 flex-1 overflow-y-auto">
        <div>
          <span className="text-xs font-light">Product Information</span>
          <div className="grid grid-cols-3 gap-6 mt-2">
            <div className="col-span-1">
              <TextInput
                id="type"
                label="Product Type"
                type="text"
                placeholder="e.g. Meters"
                {...form}
              />
            </div>
            <div className="col-span-2">
              <TextInput
                id="description"
                label="Description"
                type="text"
                placeholder="e.g. This product..."
                {...form}
              />
            </div>

            <div className="col-span-1">
              <TextInput
                id="samplingTechnique"
                label="Sampling Technique"
                type="text"
                placeholder="e.g. Random Sampling"
                {...form}
              />
            </div>  
            <div className="col-span-1">
              <TextInput
                id="sampledQuantity"
                label="Sampled Quantity"
                type="number"
                min={0}
                step={1}
                placeholder="e.g. 100"
                {...form}
              />
            </div>
            <div className="col-span-1">
              <TextInput
                id="testEquipment"
                label="Test Equipment"
                type="text"
                placeholder="e.g. Automated Test Bench"
                {...form}
              />
            </div>
            <div className="col-span-2">
              <TextInput
                id="packaging"
                label="Packaging"
                type="text"
                placeholder="e.g. Anti-static bags"
                {...form}
              />
            </div>
            <div className="col-start-1 col-span-3">
              <TagArea
                id="serialNumbers"
                label="Serial Numbers"
                placeholder="e.g. P13013093939"
                required
                {...form}
              />
            </div>

          </div>
        </div>
      </div>
      <div className="bg-gray-50 dark:bg-gray-800 px-4 py-3 sm:py-4 sm:px-6 sm:flex sm:flex-row-reverse border-t border-gray-200">
        <button
          type="button"
          data-invalid={!form.isValid}
          onClick={wrapClick(form.handleSubmit)}
          className="w-full inline-flex justify-center data-invalid:bg-gray-200 data-invalid:border-gray-400 data-invalid:cursor-not-allowed data-invalid:text-gray-600 rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary-600 text-base font-medium text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 sm:ml-3 sm:w-auto sm:text-sm"
        >
          Next
        </button>
        <button
          type="button"
          className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 dark:border-gray-600 shadow-sm px-4 py-2 bg-white dark:bg-gray-900 text-base font-medium text-gray-700 dark:text-gray-200 hover:bg-gray-50 hover:dark:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
          onClick={wrapClick(form.resetForm)}
        >
          Cancel
        </button>
        <button
          type="button"
          onClick={wrapClick(handlePrevious)}
          className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 dark:border-gray-600 shadow-sm px-4 py-2 bg-white dark:bg-gray-900 text-base font-medium text-gray-700 dark:text-gray-200 hover:bg-gray-50 hover:dark:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
        >
          Previous
        </button>
      </div>
    </div>
  );
};

export default ProductInfoForm;
